<template>
  <div class="parallex">

    <div v-if="isMobile" class="gallery">
      <!-- <div v-for="(num, index) in Array(14).fill('')" :key="index" class="gallery-slide">
        <img :src="`/frontImages/a${index + 1}.jpg`" />
      </div> -->
      <div v-for="(num, index) in ['1', '2', '3', '4', '5', '7', '10', '11', '12', '13', '14', '15', '16']" :key="index" class="gallery-slide">
        <img :src="`/frontImages/a${num}.jpg`" />
      </div>
    </div>

    <div v-else class="swiper-container">
      <div class="swiper-wrapper">
        <!-- <div v-for="(num, index) in Array(14).fill('')" :key="index" class="swiper-slide">
          <img :src="`/frontImages/a${index + 1}.jpg`" />
        </div> -->
        <div v-for="(num, index) in ['1', '2', '3', '4', '5', '7', '10', '11', '12', '13', '14', '15', '16']" :key="index" class="swiper-slide">
          <img :src="`/frontImages/a${num}.jpg`" />
        </div>
      </div>

      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
  </div>
</template>

<script>
  import Swiper from "swiper/dist/js/swiper.js";

  export default {
    data() {
      return {
        swiper: null,
        isMobile: (window.innerWidth <= 450) ? true : false,
      };
    },
    mounted() {
      if (!this.isMobile) {

        this.$nextTick(() => {
          this.swiper = new Swiper(".swiper-container", {
            slidesPerView: 3,
            spaceBetween: 30,
            slidesPerGroup: 1,
            loop: true,
            loopFillGroupWithBlank: false,
            snapOnRelease: true,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
            },
            // freeMode: true
          });
        });

      }
    }
  };
</script>

<style src="../assets/css/swiper.css"></style>
<style scoped>
  .parallexDiv {
    padding: 5rem;
    /* background-image: url("../assets/lounge.jpg"); */

    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    position: relative;
  }

  @media only screen and (max-device-width: 1366px) {
    .parallexDiv {
      background-attachment: scroll;
    }
  }

  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.25);
    cursor: pointer;
  }

  .swiper-container {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }

  .swiper-slide>img {
    width: 100%;
    height: 100%;
  }

  .titleText {
    color: white;
  }

  .card-body {
    min-height: 10rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .titleText {
    margin-top: 2rem;
  }

  .firstDeck {
    padding-top: 2rem;
  }

  .secondDeck {
    padding-bottom: 1rem;
  }

  .text {
    min-height: 20rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .gallery {
    display: flex;
    align-items: center;
    overflow-x: scroll;
    scroll-padding: 0 50%;
    scroll-snap-type: x mandatory;
    overflow-y: hidden;
  }

  .gallery-slide {
    scroll-snap-align: center;
    display: inline-block;
    border-radius: 3px;
    font-size: 0;
    width: 100vw;
    height: 400px;
  }

  .gallery-slide img {
    width: 80vw;
    height: 100%;
    object-fit: contain;
    margin: 0.5rem;
  }
</style>